const toVND = (number) => {
  const moneyWithDot = number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  return moneyWithDot.slice(0, moneyWithDot.indexOf(".")) + " vnđ";
};

export default toVND;
